import { render, staticRenderFns } from "./OnBoarding.vue?vue&type=template&id=4a870ff6&"
import script from "./OnBoarding.vue?vue&type=script&lang=ts&"
export * from "./OnBoarding.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports